import {
  ApiTwoTone,
  IdcardTwoTone,
  ReconciliationTwoTone,
} from '@ant-design/icons';
import { Collapse, type CollapseProps, type FormInstance } from 'antd';
import { t } from 'i18next';
import React from 'react';

import { QuestionTooltip } from '@client/components/QuestionTooltip';
import styles from '@client/pages/features/features.module.less';
import { GenerateApiKey } from '@client/pages/tenants/tenant/GenerateApiKey';
import { TenantApi } from '@client/pages/tenants/tenant/tenant.api';
import { TenantInfo } from '@client/pages/tenants/tenant/tenant.info';
import { TenantKYB } from '@client/pages/tenants/tenant/tenant.kyb';
import { useLoading } from '@client/store/loading.store';
import { stopPropagation } from '@client/utils/document.util';

import type { ISubscription, ITenant } from '@common/types';

interface IApiKeyCreationForm {
  disabled?: boolean;
  loading?: boolean;
  formRef: FormInstance;
  tenant: ITenant | null;
  refetchSubscriptions: () => void;
  subscriptions: ISubscription[];
}

export const ApiKeyCreationForm = (
  props: IApiKeyCreationForm,
): React.ReactNode => {
  const { disabled, formRef, refetchSubscriptions, subscriptions, tenant } =
    props;

  const { loading } = useLoading();

  // const [showApiKeyModal, setShowApiKeyModal] = useState(false);
  // const [generatedApiKey, setGeneratedApiKey] = useState('');

  // const handleSubmit = async (values) => {
  //   // setLoading(true);
  //   try {
  //     // Here will be the API request for client creation and API key generation
  //     const response = await fetch('/api/clients/register', {
  //       method: 'POST',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(values),
  //     });
  //
  //     const data = await response.json();
  //
  //     if (response.ok) {
  //       // setGeneratedApiKey(data.apiKey);
  //       // setShowApiKeyModal(true);
  //       // form.resetFields();
  //       // onApiKeyCreated && onApiKeyCreated();
  //     } else {
  //       // message.error('Error creating API key: ' + data.message);
  //     }
  //   } catch (error) {
  //     // message.error('Error creating API key');
  //   } finally {
  //     // setLoading(false);
  //   }
  // };

  const tenantItems: CollapseProps['items'] = [
    {
      key: 'info',
      forceRender: true,
      label: (
        <div className={styles.chipLabel}>
          <IdcardTwoTone />
          {t('tenant.info')}
        </div>
      ),
      children: <TenantInfo disabled={disabled} />,
      extra: (
        <div onClick={stopPropagation}>
          <QuestionTooltip title={t('tenant.info.helper')} />
        </div>
      ),
    },
    {
      key: 'verification',
      forceRender: true,
      label: (
        <div className={styles.chipLabel}>
          <ReconciliationTwoTone />
          {t('tenant.verification')}
        </div>
      ),
      children: (
        <TenantKYB tenant={tenant} disabled={disabled} formRef={formRef} />
      ),
      extra: (
        <div onClick={stopPropagation}>
          <QuestionTooltip title={t('tenant.verification.helper')} />
        </div>
      ),
    },
    {
      key: 'api',
      forceRender: true,
      label: (
        <div className={styles.chipLabel}>
          <ApiTwoTone />
          {t('tenant.api')}
        </div>
      ),
      children: (
        <TenantApi
          disabled={disabled}
          subscriptions={subscriptions}
          refetchSubscriptions={refetchSubscriptions}
          loading={loading}
        />
      ),
      extra: (
        <div className={styles.extraPanel} onClick={stopPropagation}>
          <GenerateApiKey disabled={disabled} tenant={tenant} />
          <QuestionTooltip title={t('tenant.api.helper')} />
        </div>
      ),
    },
  ];

  return (
    <>
      <Collapse items={tenantItems} defaultActiveKey={['info']} />

      {/*<Modal*/}
      {/*  title="API Key Successfully Created"*/}
      {/*  open={showApiKeyModal}*/}
      {/*  onCancel={() => setShowApiKeyModal(false)}*/}
      {/*  footer={[*/}
      {/*    <Button key="copy" type="primary" onClick={handleCopyApiKey}>*/}
      {/*      Copy Key*/}
      {/*    </Button>,*/}
      {/*    <Button key="close" onClick={() => setShowApiKeyModal(false)}>*/}
      {/*      Close*/}
      {/*    </Button>,*/}
      {/*  ]}*/}
      {/*>*/}
      {/*  <div style={{ padding: '20px 0' }}>*/}

      {/*  </div>*/}
      {/*</Modal>*/}
    </>
  );
};
